import { jsx as _jsx } from "tsx-dom/jsx-runtime";
import { StaticStyles } from "./static-styles.js";
import { DynamicStyles } from "./dynamic-styles.js";
import { MainContainer } from "./container.js";
import { SplashScreen } from "./splash-screen.js";
import { SaveManager } from "./save-manager.js";
import { VolumeControls } from "./volume-controls.js";
import { UnsupportedVideo } from "./unsupported-video.js";
import { HardwareAcceleration } from "./hardware-acceleration.js";
import { ClipboardPermission } from "./clipboard-permission.js";
import { ContextMenuOverlay } from "./context-menu-overlay.js";
/*
 *
 * The shadow template which is used to fill the actual Ruffle player element
 * on the page.
 *
 */
export const ruffleShadowTemplate = document.createElement("template");
ruffleShadowTemplate.content.appendChild(_jsx(StaticStyles, {}));
ruffleShadowTemplate.content.appendChild(_jsx(DynamicStyles, {}));
ruffleShadowTemplate.content.appendChild(_jsx(MainContainer, {}));
ruffleShadowTemplate.content.appendChild(_jsx(SplashScreen, {}));
ruffleShadowTemplate.content.appendChild(_jsx(SaveManager, {}));
ruffleShadowTemplate.content.appendChild(_jsx(VolumeControls, {}));
ruffleShadowTemplate.content.appendChild(_jsx(UnsupportedVideo, {}));
ruffleShadowTemplate.content.appendChild(_jsx(HardwareAcceleration, {}));
ruffleShadowTemplate.content.appendChild(_jsx(ClipboardPermission, {}));
ruffleShadowTemplate.content.appendChild(_jsx(ContextMenuOverlay, {}));
